import React, { useEffect } from "react";
import App from "./App";
import { Router } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";
import { history } from "./_helpers/history";
import { restoreAccessToken, setAuthToken } from "./_helpers/auth";
import { queryClient } from "./_helpers/query";
import { ReactQueryDevtools } from "react-query/devtools";
import "./styles/global.css";
import "./styles/tables.css";
import "./styles/anims.css";
// import "./qui/forms.css"
import ReactGA from "react-ga4";
import { useAtomValue } from "jotai";
import { themeConfigAtom } from "./_helpers/theme";

// import "antd/dist/antd.variable.min.css";
import { ConfigProvider, theme } from "antd";

const access_token = restoreAccessToken();
if (access_token) {
    setAuthToken(access_token);
} else {
    setAuthToken();
}

// Injects all AntD design tokens as --ant-* CSS custom properties on :root
// so they are available in plain HTML elements outside AntD component subtrees.
function GlobalCssVarInjector() {
    const { token } = theme.useToken();
    useEffect(() => {
        const root = document.documentElement;
        Object.entries(token).forEach(([key, value]) => {
            if (typeof value === "string" || typeof value === "number") {
                const varName =
                    "--ant-" + key.replace(/([A-Z])/g, "-$1").toLowerCase();
                root.style.setProperty(varName, String(value));
            }
        });
    }, [token]);
    return null;
}

const Application = () => {
    const themeConfig = useAtomValue(themeConfigAtom);

    useEffect(() => {
        ReactGA.initialize("G-8P3NE3T6QD");
    }, []);

    // Sync CSS vars with the active theme tokens
    useEffect(() => {
        const root = document.documentElement;
        const t = themeConfig.token ?? {};
        root.style.setProperty("--primary-color", t.colorPrimary);
        root.style.setProperty("--border-color", t.colorBorder);
        root.style.setProperty("--color-bg-container", t.colorBgContainer);
        root.style.setProperty("--color-text-tertiary", t.colorTextTertiary);
        root.style.setProperty("--color-primary-bg", t.colorPrimaryBg);
        root.style.setProperty("--color-text", t.colorText);
        if (t.fontFamilyHeading) {
            root.style.setProperty("--font-family-heading", t.fontFamilyHeading);
        }
        if (t.fontFamily) {
            root.style.setProperty("--font-family-body", t.fontFamily);
        }
    }, [themeConfig]);

    return (
        <ConfigProvider theme={{ ...themeConfig, cssVar: true }}>
            <GlobalCssVarInjector />
            <Router history={history}>
                <QueryClientProvider client={queryClient}>
                    <App />
                    {/* On mobile PWAs, native browser history handles back-button navigation. */}
                    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                </QueryClientProvider>
            </Router>
        </ConfigProvider>
    );
};
export default Application;
